exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".site-nav-desktop-shop-menu .section-title[data-v-0f0bee8e] {\n  border-bottom: 1px solid #e0e0e0;\n}\n.site-nav-desktop-shop-menu .category-padding[data-v-0f0bee8e] {\n  padding-left: 1em;\n  padding-right: 1em;\n}\n.site-nav-desktop-shop-menu li.sub-menu-item[data-v-0f0bee8e] {\n  padding: 0.5em 0;\n}\n.site-nav-desktop-shop-menu .menu-section[data-v-0f0bee8e]:last-child {\n  float: right;\n}\n", ""]);

// exports
